import roundTime from '../roundTime';

const toMinutes = (value) => roundTime(value) / 60;

export default toMinutes;
